/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Subclip model module.
 * @module model/Subclip
 * @version 1.0.0
 */
class Subclip {
    /**
     * Constructs a new <code>Subclip</code>.
     * @alias module:model/Subclip
     */
    constructor() { 
        
        Subclip.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Subclip</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Subclip} obj Optional instance to populate.
     * @return {module:model/Subclip} The populated <code>Subclip</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Subclip();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('assetID')) {
                obj['assetID'] = ApiClient.convertToType(data['assetID'], 'String');
            }
            if (data.hasOwnProperty('cartID')) {
                obj['cartID'] = ApiClient.convertToType(data['cartID'], 'String');
            }
            if (data.hasOwnProperty('cartName')) {
                obj['cartName'] = ApiClient.convertToType(data['cartName'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('note')) {
                obj['note'] = ApiClient.convertToType(data['note'], 'String');
            }
            if (data.hasOwnProperty('progress')) {
                obj['progress'] = ApiClient.convertToType(data['progress'], 'Number');
            }
            if (data.hasOwnProperty('scheduled')) {
                obj['scheduled'] = ApiClient.convertToType(data['scheduled'], 'Date');
            }
            if (data.hasOwnProperty('started')) {
                obj['started'] = ApiClient.convertToType(data['started'], 'Date');
            }
            if (data.hasOwnProperty('subclipPriority')) {
                obj['subclipPriority'] = ApiClient.convertToType(data['subclipPriority'], 'String');
            }
            if (data.hasOwnProperty('subclipStatus')) {
                obj['subclipStatus'] = ApiClient.convertToType(data['subclipStatus'], 'String');
            }
            if (data.hasOwnProperty('tcIn')) {
                obj['tcIn'] = ApiClient.convertToType(data['tcIn'], 'String');
            }
            if (data.hasOwnProperty('tcOut')) {
                obj['tcOut'] = ApiClient.convertToType(data['tcOut'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Subclip</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Subclip</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['assetID'] && !(typeof data['assetID'] === 'string' || data['assetID'] instanceof String)) {
            throw new Error("Expected the field `assetID` to be a primitive type in the JSON string but got " + data['assetID']);
        }
        // ensure the json data is a string
        if (data['cartID'] && !(typeof data['cartID'] === 'string' || data['cartID'] instanceof String)) {
            throw new Error("Expected the field `cartID` to be a primitive type in the JSON string but got " + data['cartID']);
        }
        // ensure the json data is a string
        if (data['cartName'] && !(typeof data['cartName'] === 'string' || data['cartName'] instanceof String)) {
            throw new Error("Expected the field `cartName` to be a primitive type in the JSON string but got " + data['cartName']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['note'] && !(typeof data['note'] === 'string' || data['note'] instanceof String)) {
            throw new Error("Expected the field `note` to be a primitive type in the JSON string but got " + data['note']);
        }
        // ensure the json data is a string
        if (data['subclipPriority'] && !(typeof data['subclipPriority'] === 'string' || data['subclipPriority'] instanceof String)) {
            throw new Error("Expected the field `subclipPriority` to be a primitive type in the JSON string but got " + data['subclipPriority']);
        }
        // ensure the json data is a string
        if (data['subclipStatus'] && !(typeof data['subclipStatus'] === 'string' || data['subclipStatus'] instanceof String)) {
            throw new Error("Expected the field `subclipStatus` to be a primitive type in the JSON string but got " + data['subclipStatus']);
        }
        // ensure the json data is a string
        if (data['tcIn'] && !(typeof data['tcIn'] === 'string' || data['tcIn'] instanceof String)) {
            throw new Error("Expected the field `tcIn` to be a primitive type in the JSON string but got " + data['tcIn']);
        }
        // ensure the json data is a string
        if (data['tcOut'] && !(typeof data['tcOut'] === 'string' || data['tcOut'] instanceof String)) {
            throw new Error("Expected the field `tcOut` to be a primitive type in the JSON string but got " + data['tcOut']);
        }

        return true;
    }


}



/**
 * @member {String} id
 */
Subclip.prototype['id'] = undefined;

/**
 * @member {String} assetID
 */
Subclip.prototype['assetID'] = undefined;

/**
 * @member {String} cartID
 */
Subclip.prototype['cartID'] = undefined;

/**
 * @member {String} cartName
 */
Subclip.prototype['cartName'] = undefined;

/**
 * @member {String} name
 */
Subclip.prototype['name'] = undefined;

/**
 * @member {String} note
 */
Subclip.prototype['note'] = undefined;

/**
 * @member {Number} progress
 */
Subclip.prototype['progress'] = undefined;

/**
 * @member {Date} scheduled
 */
Subclip.prototype['scheduled'] = undefined;

/**
 * @member {Date} started
 */
Subclip.prototype['started'] = undefined;

/**
 * @member {module:model/Subclip.SubclipPriorityEnum} subclipPriority
 */
Subclip.prototype['subclipPriority'] = undefined;

/**
 * @member {module:model/Subclip.SubclipStatusEnum} subclipStatus
 */
Subclip.prototype['subclipStatus'] = undefined;

/**
 * @member {String} tcIn
 */
Subclip.prototype['tcIn'] = undefined;

/**
 * @member {String} tcOut
 */
Subclip.prototype['tcOut'] = undefined;





/**
 * Allowed values for the <code>subclipPriority</code> property.
 * @enum {String}
 * @readonly
 */
Subclip['SubclipPriorityEnum'] = {

    /**
     * value: "LOW"
     * @const
     */
    "LOW": "LOW",

    /**
     * value: "MEDIUM"
     * @const
     */
    "MEDIUM": "MEDIUM",

    /**
     * value: "HIGH"
     * @const
     */
    "HIGH": "HIGH"
};


/**
 * Allowed values for the <code>subclipStatus</code> property.
 * @enum {String}
 * @readonly
 */
Subclip['SubclipStatusEnum'] = {

    /**
     * value: "SCHEDULED"
     * @const
     */
    "SCHEDULED": "SCHEDULED",

    /**
     * value: "COMPLETED"
     * @const
     */
    "COMPLETED": "COMPLETED",

    /**
     * value: "RUNNING"
     * @const
     */
    "RUNNING": "RUNNING",

    /**
     * value: "FAILED"
     * @const
     */
    "FAILED": "FAILED",

    /**
     * value: "CANCELLED"
     * @const
     */
    "CANCELLED": "CANCELLED",

    /**
     * value: "READING"
     * @const
     */
    "READING": "READING",

    /**
     * value: "NEW"
     * @const
     */
    "NEW": "NEW"
};



export default Subclip;

